import { render, staticRenderFns } from "./vehicle-info-group-tree.vue?vue&type=template&id=5b94d4f0"
import script from "./vehicle-info-group-tree.vue?vue&type=script&lang=js"
export * from "./vehicle-info-group-tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports